<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('version.changelog.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>


      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="istype('Machine')">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machine"
            :items="machineSelectItems"
            :error-messages="machineErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('version.changelog.machine')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="istype('Toolhead')">
          <v-combobox
            v-if="toolheadSelectItems"
            v-model="item.toolhead"
            :items="toolheadSelectItems"
            :error-messages="toolheadErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('version.changelog.toolhead')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6" v-if="istype('Material supply')">
          <v-combobox
            v-if="materialsupplySelectItems"
            v-model="item.materialSupply"
            :items="materialsupplySelectItems"
            :error-messages="materialsupplyErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('version.changelog.materialsupply')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="istype('Control Unit')">
          <v-combobox
            v-if="controlunitSelectItems"
            v-model="item.controlUnit"
            :items="controlunitSelectItems"
            :error-messages="controlunitErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('version.changelog.controlunit')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6" v-if="istype('Industrial computer')">
          <v-combobox
            v-if="industrialcomputerSelectItems"
            v-model="item.industrialComputer"
            :items="industrialcomputerSelectItems"
            :error-messages="industrialcomputerErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('version.changelog.industrialcomputer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="istype('Operating system')">
          <v-combobox
            v-if="operatingsystemSelectItems"
            v-model="item.operatingSystem"
            :items="operatingsystemSelectItems"
            :error-messages="operatingsystemErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('version.changelog.operatingsystem')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6" v-if="istype('Printing surface')">
          <v-combobox
            v-if="printingsurfaceSelectItems"
            v-model="item.printingSurface"
            :items="printingsurfaceSelectItems"
            :error-messages="printingsurfaceErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('version.changelog.printingsurface')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="istype('Accessory')">
          <v-combobox
            v-if="accessorySelectItems"
            v-model="item.accessory"
            :items="accessorySelectItems"
            :error-messages="accessoryErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('version.changelog.accessory')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6" v-if="istype('Software')">
          <v-combobox
            v-if="softwareversionSelectItems"
            v-model="item.softwareVersion"
            :items="softwareversionSelectItems"
            :error-messages="softwareversionErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('version.changelog.softwareversion')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="istype('Option')">
          <v-combobox
            v-if="optionSelectItems"
            v-model="item.option"
            :items="optionSelectItems"
            :error-messages="optionErrors"
            :no-data-text="$t('global.no_result')"
    :placeholder="$t('global.no_select')"
    clearable
            :label="$t('version.changelog.option')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="" >{{ $t('version.changelog.newfeatures') }}:</strong>
          <quill-editor 
            v-model="item.newFeatures" 
            class="editorQuill" 
            :options="editorOptions" 
            @input="$v.item.newFeatures.$touch()" 
            :error-messages="newfeaturesErrors"
            >
          </quill-editor>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <strong class="" >{{ $t('version.changelog.bugfixes') }}:</strong>
          <quill-editor 
            v-model="item.bugFixes" 
            class="editorQuill" 
            :options="editorOptions" 
            @input="$v.item.bugFixes.$touch()" 
            :error-messages="bugfixesErrors"
            >
          </quill-editor>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <strong class="" >{{ $t('version.changelog.knownbugs') }}:</strong>
          <quill-editor 
            v-model="item.knownBugs" 
            class="editorQuill" 
            :options="editorOptions" 
            @input="$v.item.knownBugs.$touch()" 
            :error-messages="knownBugsErrors"
            >
          </quill-editor>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <strong class="" >{{ $t('version.changelog.notes') }}:</strong>
          <quill-editor 
            v-model="item.notes" 
            class="editorQuill" 
            :options="editorOptions" 
            @input="$v.item.notes.$touch()" 
            :error-messages="notesErrors"
            >
          </quill-editor>
        </v-col>
        </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-checkbox
            v-model="item.developExternal"
            :error-messages="developexternalErrors"
            :label="$t('version.changelog.developexternal')"

            @input="$v.item.developExternal.$touch()"
            @blur="$v.item.developExternal.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="userSelectItems"
            v-model="item.developer"
            :items="userSelectItems"
            :error-messages="developerErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('version.changelog.developer')"
            item-text="login"
            item-value="@id"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.start"
            :label="$t('version.changelog.start')"
            :error-messages="startErrors"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.end"
            :label="$t('version.changelog.end')"
            :error-messages="endErrors"
          />
        </v-col>
        <v-col cols="12"></v-col>
      </v-row>


    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import InputDate from '../InputDate';
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'

export default {
  name: 'ChangeLogForm',
  mixins: [validationMixin],
  components: {
    InputDate,
    Loading,
    quillEditor
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.machineGetSelectItems();
      this.toolheadGetSelectItems();
      this.materialsupplyGetSelectItems();
      this.controlunitGetSelectItems();
      this.industrialcomputerGetSelectItems();
      this.printingsurfaceGetSelectItems();
      this.operatingsystemGetSelectItems();
      this.accessoryGetSelectItems();
      this.optionGetSelectItems();
      this.softwareversionGetSelectItems();
      this.userGetSelectItems({'orderCol'  : 'order[login]','order'  : 'asc'});

  },
  data() {
    return {
        name: null,
        machine: null,
        materialSupply: null,
        toolhead: null,
        controlUnit: null,
        industrialComputer: null,
        operatingSystem: null,
        printingSurface: null,
        accessory: null,
        option: null,
        softwareVersion: null,
        newFeatures: null,
        bugFixes: null,
        knownBugs: null,
        notes: null,
        developExternal: null,
        developer: null,
        start: null,
        end: null,
        editorOptions: { 
          theme: 'snow', // Thème de l'éditeur
          placeholder: 'Insérer une description',
          modules: {       
            toolbar: 
            [             
              ['bold', 'italic','underline'],
              ['blockquote','code-block'], // Options de style de texte    
              [{ 'list': 'bullet' },{ 'list': 'ordered' }]
            ]
          }
        }
    };
  },
  computed: {
      isLoading() {
        return (
           this.isLoading_machine ||
           this.isLoading_toolhead ||
           this.isLoading_materialsupply ||
           this.isLoading_controlunit ||
           this.isLoading_industrialcomputer ||
           this.isLoading_operatingsystem ||
           this.isLoading_printingsurface ||
           this.isLoading_accessory ||
           this.isLoading_option ||
           this.isLoading_softwareversion ||
           this.isLoading_user
         );
      },
      ...mapFields('machine', {
        machineSelectItems: 'selectItems',
        isLoading_machine : 'isLoading'
      }),
      ...mapFields('toolhead', {
        toolheadSelectItems: 'selectItems',
        isLoading_toolhead : 'isLoading'
      }),
      ...mapFields('materialsupply', {
        materialsupplySelectItems: 'selectItems',
        isLoading_materialsupply : 'isLoading'
      }),
      ...mapFields('controlunit', {
        controlunitSelectItems: 'selectItems',
        isLoading_controlunit : 'isLoading'
      }),
      ...mapFields('industrialcomputer', {
        industrialcomputerSelectItems: 'selectItems',
        isLoading_industrialcomputer : 'isLoading'
      }),
      ...mapFields('operatingsystem', {
        operatingsystemSelectItems: 'selectItems',
        isLoading_operatingsystem : 'isLoading'
      }),
      ...mapFields('printingsurface', {
        printingsurfaceSelectItems: 'selectItems',
        isLoading_printingsurface : 'isLoading'
      }),
      ...mapFields('accessory', {
        accessorySelectItems: 'selectItems',
        isLoading_accessory : 'isLoading'
      }),
      ...mapFields('option', {
        optionSelectItems: 'selectItems',
        isLoading_option : 'isLoading'
      }),
      ...mapFields('softwareversion', {
        softwareversionSelectItems: 'selectItems',
        isLoading_softwareversion : 'isLoading'
      }),
      ...mapFields('user', {
        userSelectItems: 'selectItems',
        isLoading_user : 'isLoading'
      }),


    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    machineErrors() {
      const errors = [];

      if (!this.$v.item.machine.$dirty) return errors;

      has(this.violations, 'machine') && errors.push(this.violations.machine);


      return errors;
    },
    toolheadErrors() {
      const errors = [];

      if (!this.$v.item.toolhead.$dirty) return errors;

      has(this.violations, 'toolhead') && errors.push(this.violations.toolhead);


      return errors;
    },
    materialsupplyErrors() {
      const errors = [];

      if (!this.$v.item.materialSupply.$dirty) return errors;

      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);


      return errors;
    },
    controlunitErrors() {
      const errors = [];

      if (!this.$v.item.controlUnit.$dirty) return errors;

      has(this.violations, 'controlUnit') && errors.push(this.violations.controlUnit);


      return errors;
    },
    industrialcomputerErrors() {
      const errors = [];

      if (!this.$v.item.industrialComputer.$dirty) return errors;

      has(this.violations, 'industrialComputer') && errors.push(this.violations.industrialComputer);


      return errors;
    },
    operatingsystemErrors() {
      const errors = [];

      if (!this.$v.item.operatingSystem.$dirty) return errors;

      has(this.violations, 'operatingSystem') && errors.push(this.violations.operatingSystem);


      return errors;
    },
    printingsurfaceErrors() {
      const errors = [];

      if (!this.$v.item.printingSurface.$dirty) return errors;

      has(this.violations, 'printingSurface') && errors.push(this.violations.printingSurface);


      return errors;
    },
    accessoryErrors() {
      const errors = [];

      if (!this.$v.item.accessory.$dirty) return errors;

      has(this.violations, 'accessory') && errors.push(this.violations.accessory);


      return errors;
    },
    optionErrors() {
      const errors = [];

      if (!this.$v.item.option.$dirty) return errors;

      has(this.violations, 'option') && errors.push(this.violations.option);


      return errors;
    },
    softwareversionErrors() {
      const errors = [];

      if (!this.$v.item.softwareVersion.$dirty) return errors;

      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);


      return errors;
    },
    developerErrors() {
      const errors = [];

      if (!this.$v.item.developer.$dirty) return errors;

      has(this.violations, 'developer') && errors.push(this.violations.developer);


      return errors;
    },

    newfeaturesErrors() {
      const errors = [];

      if (!this.$v.item.newFeatures.$dirty) return errors;

      has(this.violations, 'newFeatures') && errors.push(this.violations.newFeatures);


      return errors;
    },
    bugfixesErrors() {
      const errors = [];

      if (!this.$v.item.bugFixes.$dirty) return errors;

      has(this.violations, 'bugFixes') && errors.push(this.violations.bugFixes);


      return errors;
    },
    knownbugsErrors() {
      const errors = [];

      if (!this.$v.item.knownBugs.$dirty) return errors;

      has(this.violations, 'knownBugs') && errors.push(this.violations.knownBugs);


      return errors;
    },
    notesErrors() {
      const errors = [];

      if (!this.$v.item.notes.$dirty) return errors;

      has(this.violations, 'notes') && errors.push(this.violations.notes);


      return errors;
    },
    developexternalErrors() {
      const errors = [];

      if (!this.$v.item.developExternal.$dirty) return errors;

      has(this.violations, 'developExternal') && errors.push(this.violations.developExternal);



      return errors;
    },

    startErrors() {
      const errors = [];

      if (!this.$v.item.start.$dirty) return errors;

      has(this.violations, 'start') && errors.push(this.violations.start);

      !this.$v.item.start.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    endErrors() {
      const errors = [];

      if (!this.$v.item.end.$dirty) return errors;

      has(this.violations, 'end') && errors.push(this.violations.end);

      !this.$v.item.end.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        machineGetSelectItems: 'machine/fetchSelectItems'
      }),
      ...mapActions({
        toolheadGetSelectItems: 'toolhead/fetchSelectItems'
      }),
      ...mapActions({
        materialsupplyGetSelectItems: 'materialsupply/fetchSelectItems'
      }),
      ...mapActions({
        controlunitGetSelectItems: 'controlunit/fetchSelectItems'
      }),
      ...mapActions({
        industrialcomputerGetSelectItems: 'industrialcomputer/fetchSelectItems'
      }),
      ...mapActions({
        operatingsystemGetSelectItems: 'operatingsystem/fetchSelectItems'
      }),
      ...mapActions({
        printingsurfaceGetSelectItems: 'printingsurface/fetchSelectItems'
      }),
      ...mapActions({
        accessoryGetSelectItems: 'accessory/fetchSelectItems'
      }),
      ...mapActions({
        optionGetSelectItems: 'option/fetchSelectItems'
      }),
      ...mapActions({
        softwareversionGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
      ...mapActions({
        userGetSelectItems: 'user/fetchSelectItems'
      }),
      istype(type) {
        if(!this.item.type) {
          if(type != "Machine" && this.item.machine) return false;
          if(type != "Material supply" && this.item.materialSupply) return false;
          if(type != "Control Unit" && this.item.controlUnit) return false;
          if(type != "Industrial computer" && this.item.industrialComputer) return false;
          if(type != "Operating system" && this.item.operatingSystem) return false;
          if(type != "Printing surface" && this.item.printingSurface) return false;
          if(type != "Accessory" && this.item.accessory) return false;
          if(type != "Option" && this.item.option) return false;
          if(type != "Software" && this.item.softwareVersion) return false;
          if(type != "Toolhead" && this.item.toolhead) return false;

          return true;
        }
        return this.item.type == type ? true : false;
      },

  },
  validations: {
    item: {
      name: {
        required,
      },
      machine: {
      },
      materialSupply: {
      },
      toolhead: {
      },
      controlUnit: {
      },
      industrialComputer: {
      },
      operatingSystem: {
      },
      printingSurface: {
      },
      accessory: {
      },
      option: {
      },
      softwareVersion: {
      },
      newFeatures: {
      },
      bugFixes:{
      },
      knownBugs:{
      },
      notes:{
      },
      developExternal: {
      },
      developer: {
      },
      start: {
      },
      end: {
      },

    }
  }
};
</script>
